/**
 * Horizontal bar chart of average €/L per country — ports
 * `renderCountries()` from the legacy `static/analysis.js`.
 */

import { Bar } from "react-chartjs-2";

import { ensureChartDefaults } from "./chartDefaults";
import { usePalette } from "./usePalette";
import type { CountryPoint } from "../../../api/types";

export interface CountriesChartProps {
  points: CountryPoint[];
}

export default function CountriesChart({ points }: CountriesChartProps) {
  const palette = usePalette();
  ensureChartDefaults(palette);

  const data = {
    labels: points.map((p) => p.country),
    datasets: [
      {
        label: "Avg €/L",
        data: points.map((p) => p.avg_price_per_liter),
        backgroundColor: palette.accent,
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: "y" as const,
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          callback: (value: string | number) => Number(value).toFixed(2),
        },
      },
    },
    plugins: { legend: { display: false } },
  } as const;

  return <Bar data={data} options={options} />;
}
